const themeConfig = {};

const htmlFontSizeScale = {
  1: 14,
  2: 16,
  3: 18,
  4: 20,
  5: 22,
  6: 24,
  7: 26,
  8: 28,
  9: 30,
};

const htmlFontSizeAdjust = {
  1: -2,
  2: 0,
  3: +2,
  4: +4,
  5: +6,
  6: +8,
  7: +9,
  8: +10,
  9: +12,
};

const htmlFontSizeConfig = {
  min: 1,
  max: 3,
  normal: 2,
};

const lightDarkMode = {
  light: "light",
  dark: "dark",
};

themeConfig.htmlFontSizeConfig = htmlFontSizeConfig;
themeConfig.htmlFontSizeScale = htmlFontSizeScale;
themeConfig.htmlFontSizeAdjust = htmlFontSizeAdjust;
themeConfig.lightDarkMode = lightDarkMode;

export default themeConfig;
